export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_LOADING = "SIGNUP_LOADING";
export const SIGNUP_ERROR = "SIGNUP_ERROR";

export const LOGOUT = "LOGOUT";

export const LOGIN_FAILED = "LOGIN_FAILED";